
import * as cScroll from './concat-scroll';
import {log} from './test/rxjs-extra-ops';
import {filter, tap} from "rxjs/operators";
import {onlyMovedDown, onlyMovedUp, ScrollSnapper} from "./scroll-snapper";
import * as featureRollController from './my-vimeo-player';
import * as headerController from './header-controller';
import * as thumbsController from './thumbs';
import  LazyLoad from "vanilla-lazyload";
// import "simplebar";
// import 'simplebar/dist/simplebar.css';
import intersectionObserver from 'intersection-observer';

jQuery(window).on('beforeunload', function () {
   jQuery(window).scrollTop(0);
});

jQuery(document).ready(function(){
   jQuery('html, body').scrollTop(0);

   jQuery(window).on('load', function() {
      setTimeout(function(){
         jQuery('html, body').scrollTop(0);
      }, 0);
   });
});

document.addEventListener("DOMContentLoaded", () => {



   //let LazyLoad = require('vanilla-lazyload');
   let lazyload = new LazyLoad({
      container:
         document.getElementById('scroll-container'),
      elements_selector: '.thumb-img',
   });

   const callback = (e) => {
      //console.log(e[0].target, 'JUST OBSERVED SOME FUCKING SHIT')
      /*if(e[0].intersectionRatio > 0){

         jQuery(e[0].target).addClass('observed');
      }*/
      e.forEach( (obs,index) => {
          console.log(obs.target, 'JUST OBSERVED SOME FUCKING SHIT');
         if(obs.intersectionRatio > 0){
            jQuery(obs.target).addClass('observed');
            if(index === 0) {
               jQuery(obs.target.parentElement)
                  .addClass('observed')
            }
         }else{
            jQuery(obs.target).removeClass('observed');
         }
      })
   };
   let io = new IntersectionObserver(callback, {
      // root: document.getElementById('scroll-container'),
      threshold: 0.5
   });
   io.observe(document.getElementById('header-observe'));
   // io.observe(jQuery('#about-page h1').get(0));
   //io.observe(jQuery('#featured-work-page').get(0));
   io.observe(jQuery('#about-page').get(0));
   io.observe(jQuery('#contact-page').get(0));

   let cs = new cScroll.ConcatScroll(200);
   //logWheel(cs);

   let v = document.getElementById('vimeo-container');
   //v.style.height = window.outerHeight + "px";

   let sSnap = new ScrollSnapper(
      document.getElementById('scroll-container'),
      v,
      cs, 20
   );
   featureRollController.init('#vimeo-container h1', cs)
   headerController.init(cs, sSnap);
   thumbsController.init(cs);


});



const logWheel = (cs) => {


   cs.scrollStart$.pipe(
      log('START')
   ).subscribe();

   cs.scrollStop$.pipe(
      onlyMovedUp(),
      log('STOPPED UP')
   ).subscribe();
   cs.scrollStop$.pipe(
      onlyMovedDown(),
      log('STOPPED DOWN')
   ).subscribe();
}